import { connect } from 'react-redux'
import ShortenerForm from 'components/ShortenerForm'
import { toggleForm, closeModal } from 'actions/UiActions'
import { bindActionCreators } from 'redux'
import { authUserSocial } from 'async/login'

const ShortenerDetailsContainer = connect(
    (state) => {
      const { ui, shortener, user } = state;
      return {
        ui,
        shortener,
        user
      };
    },
    dispatch => ({
      toggleForm: bindActionCreators(toggleForm, dispatch),
      closeModal: bindActionCreators(closeModal, dispatch),
      authUser: bindActionCreators(authUserSocial, dispatch)
    })
)(ShortenerForm)

export default ShortenerDetailsContainer;




// WEBPACK FOOTER //
// ./src/containers/ShortenerDetailsContainer.jsx